import React from "react";
import {translate} from "components/common/Translate/Translate";

const OrDivider = () => {
    return (
        <div className="flex items-center justify-between">
            <hr className="w-full border-gray-300 dark:border-gray-600" />
            <span className="px-2 text-sm text-gray-500">{translate('or')}</span>
            <hr className="w-full border-gray-300  dark:border-gray-600" />
        </div>
    );
};

export default OrDivider;
